// import React  from 'react';
import React, { useEffect, useState } from "react";
import { Card, CardContent, Container, Grid, Typography } from "@mui/material";
import RoomIcon from "@mui/icons-material/Room";
//import { useRecoilValue, useRecoilCallback } from "recoil";
import {
  useRecoilCallback,
  useRecoilValue,
  useSetRecoilState,
  useRecoilState,
} from "recoil";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import { blueGrey } from "@mui/material/colors";
import ScheduleTimeButtom from "src/shared/components/buttons/ScheduleTimeButtom";
import { userState } from "src/store/user/userState";
import {
  isSexFemale,
  isSexIndeterminate,
  isSexMale,
} from "src/shared/global/helpers";
import ManageStorage from "src/shared/global/manageStorage";
import "./GlobalCssLayout.css";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
// import Typography from '@mui/material/Typography';
import Modal from "@mui/material/Modal";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import InboxIcon from "@mui/icons-material/Inbox";
import DraftsIcon from "@mui/icons-material/Drafts";

import {
  clinicasState,
  clinicasFetchState,
} from "src/SearchHours/components/autocompletes/state/atoms";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const SubHeaderUserRegistered = () => {
  const { catchErrorApi } = useCatchErrorApi();
  const { payload } = useRecoilValue(userState);
  const { uswNombres, uswApePat, uswApeMat, isaNombre, genNombre } =
    payload || {};
  const currentUrl = ManageStorage.getValueFromStorage("currentUrl");

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const welcomeUserText = (genNombre) => {
    let welcome = "Bienvenid";
    let letterChange = "(a)";

    if (isSexMale(genNombre)) letterChange = `o`;
    if (isSexFemale(genNombre)) letterChange = `a`;
    if (isSexIndeterminate(genNombre)) letterChange = `(a)`;

    return `${welcome}${letterChange}`;
  };

  const geoUserText = () => {
    let clinica = ManageStorage.getValueFromStorage("clinica");
    return clinica;
  };

  // useEffect(() => {
  //     console.log("useEffect...");
  // }, []);
  const setClinicas = useSetRecoilState(clinicasState);

  const clinicas = useRecoilValue(clinicasState);
  console.log("datosClinica --> ", clinicas);

  const loadGenerosBase = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        //setLoading(true)
        const release = snapshot.retain();
        try {
          // const generrosFetch = await snapshot.getPromise(generosBaseFetchState);
          // setGenerosBase(generrosFetch)

          //------
          const clinicasFetch = snapshot.getPromise(clinicasFetchState);
          const responses = await Promise.all([clinicasFetch]);
          setClinicas(responses[0]);
          //setClinicas(clinicasFetch);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          //setLoading(false)
          release();
        }
      },
    []
  );

  useEffect(() => {
    loadGenerosBase();
  }, [loadGenerosBase]);

  const handleClick = (event) => {
    console.log(event);
    console.log("clinicax => ", event);
    ManageStorage.setItemStorage("clinica", event);
    handleClose();
    window.location.reload(false);
  };

  return (
    <>
      <div className="cards">
        <div className="card col-left">
          <div>
            <Typography textAlign={"start"} variant="h6" color={blueGrey[100]}>
              {welcomeUserText(genNombre)},
            </Typography>
          </div>
          <div>
            <Typography
              textAlign="start"
              variant="h2"
              color="white"
              paddingY={1}
              fontWeight={900}
              style={{ textTransform: "uppercase" }}
            >
              {`${uswNombres || ""} ${uswApePat || ""} ${uswApeMat || ""}`}
            </Typography>
          </div>
          <Box
            component={"div"}
            sx={{ display: "flex", alignContent: "center", alignItems: "center" }}
          >
            <RoomIcon style={{ marginLeft: "-4px" }} />
            <Button onClick={handleOpen} color="secondary">
              {geoUserText()}
            </Button>
            {isaNombre ? `- ${isaNombre}` : ""}
          </Box>
        </div>
        <div className="card centrar">
          {currentUrl && !currentUrl.includes("/resultado-busqueda") && (
            <ScheduleTimeButtom />
          )}
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <nav aria-label="secondary mailbox folders">
            <List>
              {clinicas &&
                clinicas.map((item, index) => (
                  <ListItem key={item.sedNombre}>
                    <ListItemButton
                      component="a"
                      onClick={(event) => {
                        console.log("top suggestion clicked");
                        handleClick(event.target.textContent);
                      }}
                    >
                      <ListItemText primary={item.sedNombre} />
                    </ListItemButton>
                  </ListItem>
                ))}
            </List>
          </nav>
        </Box>
      </Modal>
    </>
  );

  // return (
  //     <Container>
  //         <Card sx={{ ...cardBase }}>
  //             <CardContent style={{ padding: 0 ,backgroundColor: "#668099" }}>
  //                 <Grid container alignItems={"center"}>
  //                     <Grid item xs={12} md={9}>
  //                         <Typography textAlign={"start"} variant="h6" color={blueGrey[100]}>
  //                             {welcomeUserText(genNombre)},
  //                         </Typography>
  //                         <Typography textAlign="start" variant="h2" color="white" paddingY={1} fontWeight={900} style={{ textTransform: "uppercase" }}>
  //                             {`${uswNombres || ''} ${uswApePat || ''} ${uswApeMat || ''}`}
  //                         </Typography>

  //                         <Typography style={{ display: 'flex', }} textAlign="start" variant="h6" color={blueGrey[100]} lineHeight={"30px"} gutterBottom>
  //                             <RoomIcon style={{ marginLeft: '-4px' }} /> {geoUserText()} {isaNombre ? `- ${isaNombre}` : ''}
  //                         </Typography>
  //                     </Grid>

  //                     {
  //                         currentUrl && !currentUrl.includes('/resultado-busqueda') && (
  //                             <Grid item xs={12} md={3} paddingY={2}>
  //                                 <ScheduleTimeButtom />
  //                             </Grid>
  //                         )
  //                     }
  //                 </Grid>
  //             </CardContent>
  //         </Card>
  //     </Container >
  // );
};

export default SubHeaderUserRegistered;
